import { useEffect } from 'react'
import { initPostHog, identifyUser } from './index'

const isInternalUser = me => me.isEdgeSuperuser || me.isDemoCustomer

function usePostHog(me) {
  useEffect(() => {
    const enabled = process.env.REACT_APP_POSTHOG_ENABLED === 'true'
    const key = process.env.REACT_APP_POSTHOG_KEY
    const host = process.env.REACT_APP_POSTHOG_HOST
    if (!enabled || !key || !host || !me || isInternalUser(me)) {
      return
    }

    initPostHog(key, host)
    identifyUser(me)
  }, [me])
}

export { usePostHog }
